<template>
    <div id="carouselExampleSlidesOnly" class="carousel slide m-0 carousel-fade" data-bs-ride="carousel">
        <div class="carousel-inner vh-100">
            <div class="carousel-item h-100 active" style="background: url(/img/luminaire-selection-tool/lst-slider/templed-slider-6.jpg);background-size:cover;'"></div>
            <div class="carousel-item h-100" style="background: url(/img/luminaire-selection-tool/lst-slider/templed-slider-5.jpg);background-size:cover;'"></div>
            <div class="carousel-item h-100" style="background: url(/img/luminaire-selection-tool/lst-slider/templed-slider-1.jpg);background-size:cover;'"></div>
            <div class="carousel-item h-100" style="background: url(/img/luminaire-selection-tool/lst-slider/templed-slider-4.jpg);background-size:cover;'"></div>
            <div class="carousel-item h-100" style="background: url(/images/templed-konfigurator-home.jpg);background-size:cover;'"></div>
            <div class="carousel-item h-100" style="background: url(/img/luminaire-selection-tool/lst-slider/templed-slider-2.jpg);background-size:cover;'"></div>
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {
            this.activateSlider();
        },

        methods: {

            activateSlider () {
                $( document ).ready(function() {
                    $('.carousel').carousel({
                        interval: 6000,
                        keyboard: false,
                        pause: false,
                        ride: 'carousel',
                        wrap: true,
                    });
                });
            },

        }
    }
</script>
